// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"da9e296a","213":"9e7bde2b","475":"2a988969","580":"73f9d35b","591":"f0938731","747":"9a57d74c"}[chunkId] + ".chunk.js";
};